import { useState } from 'react';
import { Flex, Text, Input, Button } from '@nula/core-ui';
import { useWorkspaceCollections } from '@/lib/sync/hooks/use-workspace-collections';
import styles from './add-to-collection-submenu.module.css';

const MAX_RESULTS = 6;

interface AddToCollectionSubmenuProps {
  onAdd: (collectionId: string) => void;
}

/**
 * Content of the "Add to collection ▸" Dropdown submenu: a search field over a
 * filtered list of (non-archived) collections. Rendered inside the Dropdown's
 * side flyout, so it needs no positioning of its own.
 */
export function AddToCollectionSubmenu({ onAdd }: AddToCollectionSubmenuProps) {
  const [search, setSearch] = useState('');
  const collections = useWorkspaceCollections();

  const results = collections
    .filter((c) => !c.isArchived)
    .filter((c) => c.name.toLowerCase().includes(search.toLowerCase()))
    .slice(0, MAX_RESULTS);

  return (
    <Flex vertical className={styles.root}>
      <Input
        autoFocus
        size="sm"
        variant="plain"
        aria-label="Search collections"
        placeholder="Search collections…"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className={styles.search}
      />
      {results.length > 0 ? (
        <Flex vertical className={styles.results}>
          {results.map((c) => (
            <Button
              key={c.id}
              variant="text"
              block
              className={styles.option}
              onClick={() => onAdd(c.id)}
            >
              <Text ellipsis className={styles.optionText}>{c.name}</Text>
            </Button>
          ))}
        </Flex>
      ) : (
        <Text size="xs" className={styles.empty}>No collections</Text>
      )}
    </Flex>
  );
}
